import React, { Component } from "react";
import { Helmet } from "react-helmet";

import Logo from "../../Assets/Images/mcrd.png";
const Reports = {
  0: {title:"2018 Report", link:"https://drive.google.com/file/d/1CpaJzo6idgM9vx8OhoUKpUt61cmHTLYY/preview"},
  1: {title:"2020 Report", link:"https://drive.google.com/file/d/1cwL63yE2OI2Cw62nHCuMacnkIGnG5phQ/preview"},
  2: {title:"MCRD 2021年 年中事工", link:"https://drive.google.com/file/d/1d7u1fpFINpfugMb7klzLUgsjA2nYfJY1/preview"},
  3: {title:"MCRD 2021年 下半年事工", link:"https://drive.google.com/file/d/1d_q7cRX7J4Q9T2ATmWgl1vp6l_omWtuw/preview"},
};

class Report extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className="report">
        <Helmet>
          <title>CAC MCRD {Reports[this.props.report].title}</title>
          <meta property="og:url" content={"https://cacmcrd.netlify.app/Ministries/Reports/" + this.props.report} />
          <meta property="og:type" content={"organization infomation"} />
          <meta property="og:title" content={"CAC MCRD " + Reports[this.props.report].title} />
          <meta property="og:description" content={Reports[this.props.report].title} />
          <meta property="og:image" content={Logo} />
        </Helmet>
        <iframe width="100%" height="100%" src={Reports[this.props.report].link} />
      </div>
    );
  }
}

export default Report;
